import type { ReactNode } from "react";
import { cn } from "@/lib/cn";

export type BadgeVariant = "primary" | "success" | "warning" | "danger" | "info" | "neutral";

const VARIANT_CLASSES: Record<BadgeVariant, string> = {
  primary: "bg-primary-soft text-primary-text",
  success: "bg-accent-soft text-accent",
  warning: "bg-warning-soft text-warning",
  danger: "bg-danger-soft text-danger",
  info: "bg-info-soft text-info",
  neutral: "bg-surface-3 text-text-secondary",
};

export function Badge({ variant = "neutral", children, className }: { variant?: BadgeVariant; children: ReactNode; className?: string }) {
  return (
    <span className={cn("inline-flex items-center gap-1 rounded-xs px-2 py-0.5 text-small font-medium", VARIANT_CLASSES[variant], className)}>
      {children}
    </span>
  );
}
